import { AppState } from "../AppState.ts";
import { configurationReducer } from "./configuration";
import { calculationReducer } from "./calculation";
import { budgetCalculationReducer } from "./budgetCalculation";
import { AppAction } from "./index.ts";

export const combinedReducers = ({ configuration, calculation, budgetCalculation }: AppState, action: AppAction) => ({
  configuration: configurationReducer(configuration, action),
  calculation: calculationReducer(calculation, action),
  budgetCalculation: budgetCalculationReducer(budgetCalculation, action),
});
